// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PremiumInfo_wrap__1_87C","info":"PremiumInfo_info__1Zh-k","charge":"PremiumInfo_charge__2OQxp"};